import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgModule } from '@angular/core';
import { KtdGridModule } from '@katoid/angular-grid-layout';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LcsAdvancedMultiSelectModule } from '@lcs/shared/advanced-multi-select';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { RouterModule } from '@angular/router';
import { ResizeOnTabChangeDirectiveModule } from 'src/app/common-components/detail/resize-on-tab-change-directive.module';
import { TabRouterDirectiveModule } from 'src/app/common-components/detail/tab-router-directives.module';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { RegisterModule } from 'src/app/common-components/register/register.module';
import { FormatPhoneNumbersPipeModule } from 'src/app/pipes/format-phone-numbers/format-phone-numbers-pipe.module';
import { AddSpacesPipeModule } from 'src/app/pipes/split-enum-strings/add-spaces-pipe.module';
import { WaitTimeDurationPipeModule } from 'src/app/pipes/wait-time-duration-pipe/wait-time-duration-pipe.module';
import { TileViewModule } from '../tiles/views/shared/tile-view/tile-view.module';
import { QueueHistoryRegisterComponent } from './containers/queue-history-register.component';
import { QueueHistoryRegisterEffects } from './state/queue-history-register.effects';
import { queueHistoryRegisterFeatureKey, queueHistoryRegisterReducer } from './state/queue-history-register.reducer';
import { QueueHistoryRegisterQueueFilterComponent } from './views/queue-history-register-queue-filter.component';
import { QueueHistoryRegisterQueueMembersViewComponent } from './views/queue-history-register-queue-members-view.component';
import { QueueHistoryRegisterViewComponent } from './views/queue-history-register-view.component';

@NgModule({
   declarations: [
      QueueHistoryRegisterComponent,
      QueueHistoryRegisterQueueFilterComponent,
      QueueHistoryRegisterViewComponent,
      QueueHistoryRegisterQueueMembersViewComponent,
   ],
   exports: [QueueHistoryRegisterComponent],
   imports: [
      CommonModule,
      DragDropModule,
      KtdGridModule,
      FormsModule,
      RegisterModule,
      EntitySelectModule,
      AddSpacesPipeModule,
      LcsResponsiveTableModule,
      RouterModule,
      WaitTimeDurationPipeModule,
      MatIconModule,
      MatFormFieldModule,
      MatSelectModule,
      MatSlideToggleModule,
      MatTabsModule,
      MatTooltipModule,
      LcsAdvancedMultiSelectModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      FormatPhoneNumbersPipeModule,
      MatMenuModule,
      TileViewModule,
      TabRouterDirectiveModule,
      ResizeOnTabChangeDirectiveModule,
      EffectsModule.forFeature([QueueHistoryRegisterEffects]),
      StoreModule.forFeature(queueHistoryRegisterFeatureKey, queueHistoryRegisterReducer),
   ],
})
export class QueueHistoryRegisterModule {}
